import { BaseService } from './base-service';
import { ChangePasswordParamsDTO, ChangePasswordResponseDTO } from '@/core/dto/user';
import { ResponsibleDTO, GetResponsibleOptionsParamsDTO } from '@/core/dto/responsible';

class UserService extends BaseService {
	constructor(public readonly basePath: string = '/user') {
		super();
	}

	async listOptions(params: GetResponsibleOptionsParamsDTO): Promise<ResponsibleDTO[]> {
		const url = this.basePath + `/user-list/${params.organization_id}/${params.company_id}`;
		const { data } = await this.getInstance().get(url);
		return data;
	}

	async changePassword(params: ChangePasswordParamsDTO): Promise<ChangePasswordResponseDTO> {
		const url = this.basePath + '/change-password';
		const { data } = await this.getInstance().put<ChangePasswordResponseDTO>(url, params);
		return data;
	}
}

const Service = Object.freeze(new UserService());
export { Service };
